import { ChangeEvent, useEffect } from "react";
import MainHeaderStore from "../../../../stores/MainHeaderStore";

interface Props {
  store: MainHeaderStore;
  lockBodyScroll: () => void;
  unlockBodyScroll: () => void;
}

const useSearchMobMenu = ({
  store,
  lockBodyScroll,
  unlockBodyScroll,
}: Props) => {
  const onClose = () => {
    store.setIsSearchMobOpen(false);
    store.setSearchString("");
  };

  useEffect(() => {
    if (store.isSearchMobOpen) {
      lockBodyScroll();
    } else {
      unlockBodyScroll();
    }
  }, [store.isSearchMobOpen]);

  const handleOnChange = (e: ChangeEvent<HTMLInputElement>) => {
    store.setSearchString(e.target.value);
  };
  const handleFocus = () => {
    if (store.searchString.length) {
      store.setIsSearchResultOpen(true);
    }
  };

  const handleBlur = () => {
    store.setIsSearchResultOpen(false);
  };

  const clear = () => {
    store.setSearchString("");
  };
  return { onClose, handleOnChange, handleFocus, handleBlur, clear };
};

export default useSearchMobMenu;
